import { render, staticRenderFns } from "./ProfileOrders.vue?vue&type=template&id=1949b53a&"
import script from "./ProfileOrders.vue?vue&type=script&lang=js&"
export * from "./ProfileOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports